var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-overlay',{attrs:{"id":"overlay-background","show":_vm.loader === true,"variant":"dark","opacity":"0.85","blur":"2px","rounded":"sm","spinner-variant":"primary","spinner-medium":""}},[_c('contact-form')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }